import React from 'react';

import { connect } from  'react-redux';

import { Redirect, Link } from 'react-router-dom';

import {api,API_URL} from '../../actions/_request';
import swal from 'sweetalert2';
//libs
import Select , {Async}  from 'react-select';
import moment from 'moment';

import Lista_tickets from './lista_tickets_contpaq'
import * as actions from '../../actions/balancegeneral';

import ReactTable from "react-table";
import "react-table/react-table.css";
import _ from "lodash";
import IconPrint from 'react-icons/lib/fa/print';
import {
    Card, CardBlock,
    Button, ButtonGroup,
    InputGroup, InputGroupAddon, InputGroupButton,InputGroupText,
    Input,
    Badge,
    Row,
    CardTitle
} from 'reactstrap';
import { TabContent, TabPane, Nav, NavItem, NavLink, CardText, Col } from 'reactstrap';
import classnames from 'classnames';
import Fasearch from 'react-icons/lib/fa/search';
import FAprint from 'react-icons/lib/fa/print';
import IconCheckCircle from 'react-icons/lib/md/check-circle';

const requestData = (pageSize, page, sorted, filtered,fecha,fecha2,todos) => {    
    return new Promise((resolve, reject) => {
        // You can retrieve your data however you want, in this case, we will just use some local data.
        let filteredData ;
        var take= pageSize;
        var skip=pageSize * page;
        var total=1;  
        var cliente='';
        var ticket='';
        var tecnico='';
        console.log('entro a la busqueda')
        for (var i = filtered.length - 1; i >= 0; i--) {
          switch(filtered[i].id)
          {
           
              case "cliente":
              cliente=filtered[i].value;
              console.log('cliente--->',filtered[i].value);
              break; 
              case "clave":
              ticket=filtered[i].value;
              console.log('clave--->',filtered[i].value);
              break; 
              case "cancelador":
              tecnico=filtered[i].value;
              console.log('cancelador--->',filtered[i].value);
              break;              
          }
        }

        api().get(`/ticketscancelados/${fecha}/${fecha2}?take=${take}&skip=${skip}&cliente=${cliente}&ticket=${ticket}&tecnico=${tecnico}&todos=${todos}&noaprobado=1`)
        .then(function(response)
        {
           
              
             
                if(response.status === 200)
                {
                  filteredData= response.data.datos;
                  total= response.data.total;  
                  console.log('data----->',response.data)
                  // You can also use the sorting in your request, but again, you are responsible for applying it.
                  const sortedData = _.orderBy(
                    filteredData,
                    sorted.map(sort => {
                      return row => {
                        if (row[sort.id] === null || row[sort.id] === undefined) {
                          return -Infinity;
                        }
                        return typeof row[sort.id] === "string"
                        ? row[sort.id].toLowerCase()
                        : row[sort.id];
                      };
                    }),
                    sorted.map(d => (d.desc ? "desc" : "asc"))
                  );
                  const res = {
                    rows: sortedData,
                    pages: Math.ceil(total / pageSize)
                  };
                  // Here we'll simulate a server response with 500ms of delay.
                  //setTimeout(() => resolve(res), 1000);
                  //console.log(res);
                  resolve(res)
                }
               
            
        });
    });
};
const meses = [
	{label : 'Enero' , value : 1},
	{label : 'Febrero', value : 2},
	{label : 'Marzo', value : 3},
	{label : 'Abril' , value: 4},
	{label : 'Mayo' , value: 5},
	{label : 'Junio' , value: 6},
	{label : 'Julio' , value: 7},
	{label : 'Agosto' , value: 8},
	{label : 'Septiembre' , value: 9},
	{label : 'Octubre' , value: 10},
	{label : 'Noviembre' , value: 11},
	{label : 'Diciembre' , value: 12},
];

class TicketsCancelados extends React.Component{

	constructor(props){
		super(props)

		this.state = {
			 activeTab: '1',
			 data:[],
			 fecha:moment().format('Y-MM-DD'),
       fecha2:moment().format('Y-MM-DD'),
			 pages:null,
			 loading:true,
			 recargar:true,
       todos:1,
		}
		this.handleInputChange = this.handleInputChange.bind(this);
	  this.search = this.search.bind(this);
		this.toggle_tab= this.toggle_tab.bind(this);
		this.fetchData = this.fetchData.bind(this);
		this.recargar2 = this.recargar2.bind(this);
    this.confirmar = this.confirmar.bind(this);
	}

  confirmar(evt, ticket_id ) {
     
      let self = this;
      swal.queue([{
        title: 'Estas seguro?',
        text: "Se Marcara el Ticket Como Confirmado el estatus  de No aprobado",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Estoy Seguro!',
        cancelButtonText: 'Cancelar!',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return api().post('/ticketsv2/full_update/'+ticket_id,{confirmacion_no_aprobacion:1})
            .then(function(response)
            {    
                console.log('response-->',response)    
                if(response.status === 200)
                {
              
                      self.setState({recargar:false,});
                 
                }
            })
            .catch(() => {
              swal.insertQueueStep({
                type: 'error',
                title: 'Solicitar ayuda a un Administrador',
              })
            })
        }
      }])
  }
	 recargar2(){
	        this.setState({
	          recargar:true,
	      });
	    }

	fetchData(state, instance) {
        // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
        // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
        this.setState({ loading: true });
        // Request the data however you want.  Here, we'll use our mocked service we created earlier
        requestData(
          state.pageSize,
          state.page,
          state.sorted,
          state.filtered,
          this.state.fecha,
          this.state.fecha2,
          this.state.todos,
        ).then(res => {
          // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
          console.log('res-----',res)
          this.setState({
            data: res.rows,
            pages: res.pages,
            loading: false
          });
        });
    }

	search(){
		let self = this;
		self.setState({
			        	 recargar:false,
			        });
	    // api().get(`/ticketscancelados/${this.state.fecha}`)
     //    .then(function(response)
     //    {                  
     //        if(response.status === 200)
     //        { 
     //               self.setState({
			  //       	data : response.data,
			  //       });
     //        }

     //    });
	}
	toggle_tab(tab) {
        if (this.state.activeTab !== tab) {
          this.setState({
            activeTab: tab
          });
        }
      }

		formateo(value) {
			let etiqueta='$';

			var decimals =  2;
			var  separators =[',', ",", '.'];
			var number = (parseFloat(value) || 0).toFixed(decimals);
			if(number<0)
				etiqueta='$ -';

			if (number.length <= (4 + decimals))
			return etiqueta +number.replace('.', separators[separators.length - 1]);
			var parts = number.split(/[-.]/);
			value = parts[parts.length > 1 ? parts.length - 2 : 0];
			var result = value.substr(value.length - 3, 3) + (parts.length > 1 ?
			separators[separators.length - 1] + parts[parts.length - 1] : '');
			var start = value.length - 6;
			var idx = 0;
			while (start > -3) {
			result = (start > 0 ? value.substr(start, 3) : value.substr(0, 3 + start))
			+ separators[idx] + result;
			idx = (++idx) % 2;
			start -= 3;
			}
			return etiqueta + result;
		}



	 componentDidMount(){
	  let self = this;
    }


    

	handleInputChange(event) {



		if(event === null) return;
        let{fecha} = this.state;
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked?1:0 : target.value;
		const name = target.name;
		


		// this.setState({contpaq: contpaq});
		 this.setState({[name]:value,recargar:false,});


	}
	



	render(){
let { data,pages,loading,recargar } = this.state;
let permiso=false;
if (typeof this.props.auth.permisos === "undefined") {
            
          } else {
           console.log('permisos--->',this.props.auth.permisos[13])
           if(parseInt(this.props.auth.permisos[13].menu))
              permiso=true;
          
           
          }

if(recargar==false)
          setTimeout(this.recargar2() , 3);
		return(
		<Card className="px-3">
			<div className="mb-2"></div>
			<Nav tabs>
				<NavItem>
					<NavLink className={classnames({ active: this.state.activeTab === '1' })}	onClick={() => { this.toggle_tab('1'); }}	>
						Tickets No Aprobados
					</NavLink>
				</NavItem>
			</Nav>
			<TabContent activeTab={this.state.activeTab}>
				<TabPane tabId="1">
				 <div className="row">
				 <div className="col-md-1"> 
                    <div className="form-group">
                    </div>
                 </div>
                 <div className="col-sm-2">
									<div className="form-group">
										<label className>Inicio</label>
										<input
											type="date" 
											className="form-control"
											name="fecha"
											value={this.state.fecha|| ''}
											onChange={this.handleInputChange}
                      disabled={parseInt(this.state.todos)==1?true:false}
										/>
									</div>
								</div>
                <div className="col-sm-2">
                  <div className="form-group">
                    <label className>Fin</label>
                    <input
                      type="date" 
                      className="form-control"
                      name="fecha2"
                      value={this.state.fecha2|| ''}
                      onChange={this.handleInputChange}
                      disabled={parseInt(this.state.todos)==1?true:false}
                    />
                  </div>
                </div>
                <div className="col-sm-2 pt-3">
                      <div className="form-group mt-4">
                        <label >
                            <input type="checkbox"
                            name="todos" 
                            checked={parseInt(this.state.todos)==1?true:false }
                            onChange={this.handleInputChange}
                            />&nbsp;&nbsp;Sin Confirmar
                        </label>
                      </div>
                  </div>



                </div>
                <div className='row'>
	                <div className='col-sm-12'>
	                {(recargar==true&&permiso)&&<ReactTable
                              data      = {data}
                              className = "-striped -highlight"
                              columns   = {[
                                 {Header: 'Ticket', accessor: 'clave'},  
                                 {Header: 'Cliente', accessor: 'cliente'},
                                 {Header: 'Cancelo', accessor: 'cancelador'},
                                 {
                                    Header: 'Controles',
                                    filterable: false,
                                    sortable: false,
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-right">
                                                <a href={API_URL+"/ticketsv2/printNoAprobado/"+row.original.id} target="_blank">
                                                      <Button color="secondary" title=" Imprimir Ticket" >
                                                          <IconPrint  />
                                                      </Button>
                                                  </a>
                                                  {"  "}
                                                  {
                                                parseInt( row.original.confirmacion_no_aprobacion)===0?
                                                <Button
                                                 color="success"         
                                                 onClick={(evt)=>this.confirmar(evt, row.original.id )}>
                                                    <IconCheckCircle />
                                                </Button>:""
                                                }
                                                 
                                            </div>
                                        )
                                    }
                                }
                              ]}
                              SubComponent={ row => {
                                return(
                                    <Card>
                                        <CardBlock>
                                            <CardTitle className="h6 text-uppercase mb-4">Más Información</CardTitle>
                                            <div className='row'>
                                              <div className='col-6'>
                                                <h1 className="h4 text-uppercase">Tecnicos:</h1>
                                              <dl className="row">
                                                <dt className="col-sm-3 text-truncate">Creo Ticket:</dt>
                                                <dd className="col-sm-9">{row.original.creador}</dd>

                                                 <dt className="col-sm-3 text-truncate">Tecnico Asignado</dt>
                                                <dd className="col-sm-9">{row.original.asignado}</dd>

                                                <dt className="col-sm-3 text-truncate">Cobro:</dt>
                                                <dd className="col-sm-9">{row.original.cobro}</dd>                       

                                            </dl>
                                            </div>
                                              <div className='col-6'>
                                                <h1 className="h4 text-uppercase">Cliente:</h1>
                                              <dl className="row">
                                                <dt className="col-sm-3 text-truncate">Razon Social:</dt>
                                                <dd className="col-sm-9">{row.original.empresa}</dd>

                                                 <dt className="col-sm-3 text-truncate">Telefono</dt>
                                                <dd className="col-sm-9">{row.original.telefono}</dd>

                                                <dt className="col-sm-3 text-truncate">Contacto:</dt>
                                                <dd className="col-sm-9">{row.original.contacto}</dd>                       

                                            </dl>
                                            </div>
                                              
                                            </div>




                                             <h1 className="h4 text-uppercase">Ticket:</h1>

                                              
                                                  <dl className="row">  
                                                    <dt className="col-sm-3 text-truncate">Fecha y hora</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.created_at +' '+row.original.hora}}></dd>
                                                    <dt className="col-sm-3 text-truncate">Fecha de Pago</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.fecha_pago }}></dd>
                                                    <dt className="col-sm-3 text-truncate">Factura</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.factura}}></dd>
                                                    <dt className="col-sm-3 text-truncate">Remision</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.remision}}></dd>
                                                                             
                                                    <dt className="col-sm-3 text-truncate">Descripción Recepción</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.descripcion}}></dd>
                                                    <dt className="col-sm-3 text-truncate">Descripción Proceso/ Diagnostico</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.descripcion_proceso}}></dd>
                                                    {
                                                      (row.original.cancelado===1)&&
                                                      <dt className="col-sm-3 text-truncate">Descripción de Cancelado</dt>
                                                    }
                                                    {
                                                      (row.original.cancelado===1)&&
                                                      <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.motivo_cancelado}}></dd>
                                                    }
                                                  </dl>
                                                  {
                                                      (row.original.proceso_id===5)&&
                                                   <dl className="row">  
                                                    <dt className="col-sm-3 text-truncate">Fecha Garantia</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.garantia.fecha}}></dd>
                                                    <dt className="col-sm-3 text-truncate">Tecnico de Garantia</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.garantia.usuario}}></dd>
                                                                             
                                                    <dt className="col-sm-3 text-truncate">Descripcion Garantia</dt>
                                                    <dd className="col-sm-9" dangerouslySetInnerHTML={{__html: row.original.garantia.motivo}}></dd>
                                                   
                                                   
                                                  </dl>
                                                }
                                                

                                            


                                            <table className="table">
                                              <thead>
                                                <tr>
                                                  <th>Producto</th>
                                                  <th>Descripción</th> 
                                                  <th>Subtotal</th>
                                                  <th>Iva</th>
                                                  <th>Total</th>                                                 
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {
                                                  row.original.items.map((item, i) => 
                                                  <tr key={i}>
                                                   <td>{item.categoria}</td>
                                                   <td>{item.descripcion}</td>
                                                   <td>{item.subtotal_formato}</td>
                                                   <td>{item.iva_formato}</td>
                                                   <td>{item.total_formato}</td>   
                                                  </tr>)
                                                }
                                              </tbody>
                                            </table>
                                        </CardBlock>
                                    </Card>
                                )
                              }}
                              filterable 
                              defaultPageSize={10} 
                              manual // Forces table not to paginate or sort automatically, so we can handle it server-side
	                          pages={pages} // Display the total number of pages
	                          loading={loading} // Display the loading overlay when we need it
	                          onFetchData={_.debounce(this.fetchData, 500)} // Request new data when things change

                             
                            />}
	                </div>
                </div>
				</TabPane>
			</TabContent>
		</Card>
		)
	}

}

function mapStateToProps(state, ownProps) {
    return {
        balancegeneral : state.balancegeneral,
        auth:state.auth
    }
};

export default connect(mapStateToProps, actions)(TicketsCancelados)


// WEBPACK FOOTER //
// ./src/views/reportes/ticketsNoAprobados.js